export default "__VITE_ASSET__CbCRlmK7__"